/** 
 * 라우스 설정 객체.
 * state {string} state 명
 * url {string} state 명
 * templateUrl {string} template path
 * controller {string} angular 에 등록한 controller 명
 * controllerUrl {string} 지정한 controller 의 path
 * abstract {boolean} 추상 여부 - 탭과 같이 하위 여러 url 존재 시에 true 로 활성화
 * cache {boolean} 캐쉬 여부
 */
const routeConfig = [
	{
		state: 'login',
		url: '/login',
		templateUrl: 'app/views/SCR0001/SCR0001.html',
		controller: 'LoginController',
		controllerUrl: 'app/views/SCR0001/SCR0001.controller.js',
		injectUrl: [],
		abstract: false,
		cache: false
	},
	{
		state: 'main',
		url: '/main',
		templateUrl: 'app/views/wrap/wrap.html',
		controller: 'WrapController',
		controllerUrl: 'app/views/wrap/wrap.controller.js',
		injectUrl: [],
		abstract: true,
		cache: false,
		resolve: {
			bxMsg: (messageService) => messageService.init(['common', 'error', 'manageApp', 'manageMsg', 
				'mangePermission', 'manageCommSystem', 'manageTrxCode', 'manageBizCode', 'manageExtInstCode', 
				'manageFunction', 'manageUser', 'manageRole','manageDeploySystem','manageMetaInfo',
				'manageActionHistory', 'manageMciInterface', 'manageEaiInterface', 'manageFepInterface', 'extrnlMsg', 'manageCommCode'])
		},
		children: [
			{
				state: 'main.blank',
				url: '/blank',
				templateUrl: 'app/views/wrap/blank/blank.html',
				controller: 'BlankController',
				controllerUrl: 'app/views/wrap/blank/blank.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false
			},
			{
				state: 'main.manageUser',
				url: '/manageUser',
				templateUrl: 'app/views/wrap/manageUser/SCR0101.html',
				controller: 'SCR0101Controller',
				controllerUrl: 'app/views/wrap/manageUser/SCR0101.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'YN_CD'])
				}
			},
			{
				state: 'main.manageRole',
				url: '/manageRole',
				templateUrl: 'app/views/wrap/manageRole/SCR0201.html',
				controller: 'SCR0201Controller',
				controllerUrl: 'app/views/wrap/manageRole/SCR0201.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE'])
				}
			},
			{
				state: 'main.managePerm',
				url: '/managePerm',
				templateUrl: 'app/views/wrap/mangePermission/SCR0301.html',
				controller: 'SCR0301Controller',
				controllerUrl: 'app/views/wrap/mangePermission/SCR0301.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'PERM_TYPE'])
				}
			},
			{
				state: 'main.manageMsg',
				url: '/manageMsg',
				templateUrl: 'app/views/wrap/manageMsg/SCR0501.html',
				controller: 'SCR0501Controller',
				controllerUrl: 'app/views/wrap/manageMsg/SCR0501.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE','TRAN_DSCD','MSG_TYPE',
						'ISO_DATA_TYPE','YN_CD', 'CHN_DSCD', 'DATA_FORMAT_CD', 'ALIGN_CD', 'ISO_FLD_LEN_TYPE_CD', 'FILLER_CD', 'FORMAT_TYPE',
						'ISO_FLD_CHARSET_CD', 'DATA_TYPE', 'CHL_DSCD', 'PRIVACY_CD', 'ISO_BITMAP_TYPE_CD', 'IO_KEY', 'REPLACEKEY_EXT', 'REPLACEKEY_INT', 'WORK_STATUS_CD'])
				}
			},
			{
				state: 'main.manageFunction',
				url: '/manageFunction',
				templateUrl: 'app/views/wrap/manageFunction/SCR0601.html',
				controller: 'SCR0601Controller',
				controllerUrl: 'app/views/wrap/manageFunction/SCR0601.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE'])
				}
			},
			{
				state: 'main.manageDeploySystem',
				url: '/manageDeploySystem',
				templateUrl: 'app/views/wrap/manageDeploySystem/SCR1201.html',
				controller: 'SCR1201Controller',
				controllerUrl: 'app/views/wrap/manageDeploySystem/SCR1201.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE','DEPLOY_SYS_DSCD'])
				}
			},
			{
				state: 'main.manageBizCode',
				url: '/manageBizCode',
				templateUrl: 'app/views/wrap/manageBizCode/SCR1701.html',
				controller: 'SCR1701Controller',
				controllerUrl: 'app/views/wrap/manageBizCode/SCR1701.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE'])
				}
			},
			{
				state: 'main.manageTrxCode',
				url: '/manageTrxCode',
				templateUrl: 'app/views/wrap/manageTrxCode/SCR1501.html',
				controller: 'SCR1501Controller',
				controllerUrl: 'app/views/wrap/manageTrxCode/SCR1501.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'EXT_INST_TYPE'])
				}
			},
			{
				state: 'main.manageCommSystem',
				url: '/manageCommSystem',
				templateUrl: 'app/views/wrap/manageCommSystem/SCR1301.html',
				controller: 'SCR1301Controller',
				controllerUrl: 'app/views/wrap/manageCommSystem/SCR1301.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE'])
				}
			},
			{
				state: 'main.manageExtInstCode',
				url: '/manageExtInstCode',
				templateUrl: 'app/views/wrap/manageExtInstCode/SCR1601.html',
				controller: 'SCR1601Controller',
				controllerUrl: 'app/views/wrap/manageExtInstCode/SCR1601.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'EXT_INST_TYPE'])
				}
			},
			{
				state: 'main.manageMciInterface',
				url: '/manageMciInterface?id',
				templateUrl: 'app/views/wrap/manageMciInterface/SCR0701.html',
				controller: 'SCR0701Controller',
				controllerUrl: 'app/views/wrap/manageMciInterface/SCR0701.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'DEPLOY_SYS_DSCD',
						'MAPPING_DSCD','MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 'TRX_TYPE_DSCD','DEL_YN_CD'])
				}
			},
			{
				state: 'main.manageEaiInterface',
				url: '/manageEaiInterface?id',
				templateUrl: 'app/views/wrap/manageEaiInterface/SCR0801.html',
				controller: 'SCR0801Controller',
				controllerUrl: 'app/views/wrap/manageEaiInterface/SCR0801.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 
						'RECV_DB_ACT_TYPE', 'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD','DEL_YN_CD'])
				}
			},
			{
				state: 'main.manageEaiInterface2',
				url: '/manageEaiInterface2?id',
				templateUrl: 'app/views/wrap/manageEaiInterface2/SCR0801_2.html',
				controller: 'SCR0801Controller_2',
				controllerUrl: 'app/views/wrap/manageEaiInterface2/SCR0801_2.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 
						'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD', 'DEL_YN_CD'])
				}
			},
			{
				state: 'main.manageFepInterface',
				url: '/manageFepInterface?id',
				templateUrl: 'app/views/wrap/manageFepInterface/SCR0901.html',
				controller: 'SCR0901Controller',
				controllerUrl: 'app/views/wrap/manageFepInterface/SCR0901.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'DEPLOY_SYS_DSCD',
						'MAPPING_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'CONDITION_CD', 'BACK_APR_STAT', 'SYNC_DSCD_FEP',
						'WIDE_HALF_CHAR_CD', 'ENC_CD_MAPPING', 'FIELD_ENCODING_ONL', 'DEL_YN_CD', 'VALUE_TYPE'])
				}
			},
			{
				state: 'main.manageCcInterface',
				url: '/manageCcInterface?id',
				templateUrl: 'app/views/wrap/manageCcInterface/SCR1001.html',
				controller: 'SCR1001Controller',
				controllerUrl: 'app/views/wrap/manageCcInterface/SCR1001.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 
						'RECV_DB_ACT_TYPE', 'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD', 'TRX_TYPE_DSCD_CC'
						,'DEL_YN_CD'])
				}
			},
			{
				state: 'main.manageMciInterfaceDetail',
				url: '/manageMciInterfaceDetail',
				templateUrl: 'app/views/wrap/manageMciInterfaceDetail/SCR0701.html',
				controller: 'SCR0701Controller2',
				controllerUrl: 'app/views/wrap/manageMciInterfaceDetail/SCR0701.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'DEPLOY_SYS_DSCD',
						'MAPPING_DSCD','MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 'TRX_TYPE_DSCD'])
				}
			},
			{
				state: 'main.manageEaiInterfaceDetail',
				url: '/manageEaiInterfaceDetail',
				templateUrl: 'app/views/wrap/manageEaiInterfaceDetail/SCR0801.html',
				controller: 'SCR0801Controller2',
				controllerUrl: 'app/views/wrap/manageEaiInterfaceDetail/SCR0801.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 'RECV_DB_ACT_TYPE', 
						'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD'])
				}
			},
			{
				state: 'main.manageFepInterfaceDetail',
				url: '/manageFepInterfaceDetail',
				templateUrl: 'app/views/wrap/manageFepInterfaceDetail/SCR0901.html',
				controller: 'SCR0901Controller2',
				controllerUrl: 'app/views/wrap/manageFepInterfaceDetail/SCR0901.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'DEPLOY_SYS_DSCD',
						'MAPPING_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'CONDITION_CD', 'BACK_APR_STAT', 'SYNC_DSCD_FEP',
						'WIDE_HALF_CHAR_CD', 'ENC_CD_MAPPING', 'FIELD_ENCODING_ONL', 'DEL_YN_CD', 'VALUE_TYPE'])
				}
			},
			{
				state: 'main.manageEaiInterfaceDetail2',
				url: '/manageEaiInterfaceDetail2',
				templateUrl: 'app/views/wrap/manageEaiInterfaceDetail2/SCR0801_2.html',
				controller: 'SCR0801Controller_22',
				controllerUrl: 'app/views/wrap/manageEaiInterfaceDetail2/SCR0801_2.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 
						'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD'])
				}
			},
			{
				state: 'main.manageCcInterfaceDetail',
				url: '/manageCcInterfaceDetail',
				templateUrl: 'app/views/wrap/manageCcInterfaceDetail/SCR1001_2.html',
				controller: 'SCR1001Controller2',
				controllerUrl: 'app/views/wrap/manageCcInterfaceDetail/SCR1001_2.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, [
						'GRID_PAGE_SIZE','TRAN_DSCD', 'SYNC_DSCD', 'YN_CD', 'DUP_FILE_PROC_CD', 'RECORD_SEPARATOR_CD', 'BACKUP_CD',
						'WORK_STATUS_CD','SENC_RECV_DSCD', 'GEN_CYCLE_CD', 'REQ_EVENT_DSCD', 'TIMEOUT_PROC_CD', 'INTRFC_WAY_CD', 
						'MAPPING_DSCD', 'DEPLOY_SYS_DSCD', 'MSG_TYPE', 'CHL_DSCD', 'BACK_APR_STAT', 'RECV_DB_ACT_TYPE', 
						'TRAN_POST_PROC', 'TRAN_BEFORE_SCRIPT_TYPE', 'TRAN_POST_SCRIPT_TYPE', 'FIELD_ENCODING', 'WIDE_HALF_CHAR_CD', 'TRX_TYPE_DSCD_CC'])
				}
			},
			{
				state: 'main.manageAppCode',
				url: '/manageAppCode',
				templateUrl: 'app/views/wrap/manageAppCode/SCR1401.html',
				controller: 'SCR1401Controller',
				controllerUrl: 'app/views/wrap/manageAppCode/SCR1401.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'LEVEL_CD'])
				}
			},
			{
				state: 'main.manageMetaInfo',
				url: '/manageMetaInfo',
				templateUrl: 'app/views/wrap/manageMetaInfo/SCR1801.html',
				controller: 'SCR1801Controller',
				controllerUrl: 'app/views/wrap/manageMetaInfo/SCR1801.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'TRAN_DSCD'])
				}
			},
			{
				state: 'main.manageActionHistory',
				url: '/manageActionHistory',
				templateUrl: 'app/views/wrap/manageActionHistory/SCR1101.html',
				controller: 'SCR1101Controller',
				controllerUrl: 'app/views/wrap/manageActionHistory/SCR1101.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'ACTION_STAT_CD', 'HISTORY_DSCD'])
				}
			},
			{
				state: 'main.extrnlMsg',
				url: '/extrnlMsgs',
				templateUrl: 'app/views/wrap/extrnlMsg/SCR1901.html',
				controller: 'SCR1901Controller',
				controllerUrl: 'app/views/wrap/extrnlMsg/SCR1901.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'TRAN_DSCD', 'MSG_TYPE'])
				}
			},
			{
				state: 'main.manageCommCode',
				url: '/manageCommCode',
				templateUrl: 'app/views/wrap/manageCommCode/SCR2101.html',
				controller: 'SCR2101Controller',
				controllerUrl: 'app/views/wrap/manageCommCode/SCR2101.controller.js',
				injectUrl: [],
				abstract: false,
				cache: false,
				resolve: {
					codes: ($q, codeService) => _commonCode($q, codeService, ['GRID_PAGE_SIZE', 'LANG_CD'])
				}
			}
		]
	}
];

function _commonCode($q, codeService, codeIds){
	const q = $q.defer();
	const codes = {};
	
	codeService.getCodesList(codeIds)
		.then(data => {
			for(let i in codeIds) {
				codes[codeIds[i]] = data[i];
			}
			
			q.resolve(codes);
		});
	
	return q.promise;
}


/**
 * 앱 라우드 객체
 */
let appRoute = {};

/**
 * 앱 라우트 setting 함수.
 */
(function flatRouteConfig(config) {
	
	config.map(v => {
		const {state, url, templateUrl, controller, controllerUrl, injectUrl, abstract, cache, children, resolve} = v;
		
		appRoute[state] = {
				url,
				templateUrl,
				controller,
				controllerAs: 'vm',
				abstract,
				resolve: $.extend(resolve, {
					lazyLoad: ($ocLazyLoad) => {
						return $ocLazyLoad.load({
							files: [].concat(controllerUrl, injectUrl),
							cache
						});
					}
				})
		};
		
		if (children) flatRouteConfig(children);
		
	});	
	
})(routeConfig);



/**
 * 기본 모듈로 appRoute 를 export
 */
export default appRoute; 


// WEBPACK FOOTER //
// ./src/app/app.route.config.js